import constants from '@/constants'

const routes = [
  {
    path: '/contact-universe/contacts',
    name: 'contact-universe/contacts',
    component: () => import('@/views/Company/Contacts/ContactsList.vue'),
    meta: {
      requiresAuth: true,
      key: constants.ContactUniversePermssions.Main,
      pageTitle: 'Contact Universe',
      breadcrumb: [
        {
          text: 'Contact Universe',
          active: false,
        },
        {
          text: 'Contacts List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contact-universe/contacts/create',
    name: 'contact-universe/contacts/create',
    component: () => import('@/views/Company/Contacts/CreateContact.vue'),
    meta: {
      requiresAuth: true,
      key: constants.ContactUniversePermssions.Create,
      pageTitle: 'Create Contact',
      breadcrumb: [
        {
          text: 'Contact Universe',
          active: false,
          to: '/contact-universe/contacts',
        },
        {
          text: 'Contacts List',
          active: false,
          to: '/contact-universe/contacts',
        },
        {
          text: 'Add New',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contact-universe/contacts/edit/:id',
    name: 'contact-universe/contacts/edit',
    component: () => import('@/views/Company/Contacts/CreateContact.vue'),
    meta: {
      requiresAuth: true,
      key: constants.ContactUniversePermssions.Update,
      pageTitle: 'Edit Contact',
      breadcrumb: [
        {
          text: 'Contact Universe',
          active: false,
          to: '/contact-universe/contacts',
        },
        {
          text: 'Contacts List',
          active: false,
          to: '/contact-universe/contacts',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contact-universe/contacts/:id/activity',
    name: 'contact-universe/contacts/activity',
    component: () => import('@/views/Company/Contacts/ViewContactActivity.vue'),
    meta: {
      requiresAuth: true,
      key: constants.ContactUniversePermssions.ViewActivity,
      pageTitle: 'Contact Activity',
      breadcrumb: [
        {
          text: 'Contact Universe',
          active: false,
          to: '/contact-universe/contacts',
        },
        {
          text: 'Contacts List',
          active: false,
          to: '/contact-universe/contacts',
        },
        {
          text: 'Contact Activity List',
          active: true,
        },
      ],
    },
  },
]

export default routes
